// ChatPage.tsx
import React, { useEffect, useRef } from "react";
import ChatHeader from "../../components/chat-header";
import ChatMessages from "../../components/chat-messages";
import ChatFooter from "../../components/chat-footer";
import { useLayoutContext } from "../../layouts/general-layout";
import { useChat } from "../../hooks/useChat";
import "./chat.scss";

export default function ChatPage() {
  const { t } = useLayoutContext();
  const chatScrollRef = useRef<HTMLDivElement>(null);

  const {
      displayMessages,
      inputMessage,
      setInputMessage,
      isLoading,
      allStepsSolution,
      showQuestionList,
      showConfirmationButtons,
      allStepsCompleted,
      isAllQuestionsCompletedNow,
      isSolutionByImage,
      nextStep,
      selectedQuestion,
      selectedQuestionId,
      currentStepIndex,
      isSelectedQuestion,
      isFromSelfTestAnswerPreview,
      handleChat,
      handleExplainSolution,
      handlefurtherExplanation,
      handleSolutionBySteps,
      handleNextStep,
      handleUpsertExerciseHistory,
      handleMessageRendered,
      handleBackClick,
      navigate,
      ROUTERS_PATH
  } = useChat();

  useEffect(() => {
    if (chatScrollRef.current) {
      chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
    }
  }, [displayMessages]);

  useEffect(() => {
    const container = chatScrollRef.current;
    if (!container) return;

    let startY = 0;

    const handleTouchStart = (e: TouchEvent) => {
      startY = e.touches[0].clientY;
    };

    const handleTouchMove = (e: TouchEvent) => {
      const scrollTop = container.scrollTop;
      const currentY = e.touches[0].clientY;
      const isPullingDown = currentY > startY + 5;

      if (scrollTop === 0 && isPullingDown) {
        e.preventDefault();
      }
    };

    container.addEventListener("touchstart", handleTouchStart, { passive: true });
    container.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      container.removeEventListener("touchstart", handleTouchStart);
      container.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();    
    if (inputMessage.trim()) {
      await handleChat(inputMessage);
      setInputMessage("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      setInputMessage((prev) => prev + "\n");
    }
  };

  const onDisplayQuestion = () => {
    navigate(ROUTERS_PATH.EXERCISEQUESTIONS);    
  };

  return (
    <div className="chat-page">
      <ChatHeader chatHeading={selectedQuestion ? selectedQuestion : t("solutionForImage")} onBackClick={handleBackClick} />
      <ChatMessages
        messages={displayMessages}
        isLoading={isLoading}
        onShowSolution={handleSolutionBySteps}
        onDisplayQuestion={onDisplayQuestion}
        allStepsSolution={allStepsSolution}
        handlefurtherExplanation={handlefurtherExplanation}
        showQuestionList={showQuestionList}
        scrollRef={chatScrollRef}
        isSelectedQuestion={isSelectedQuestion}
        showConfirmationButtons={showConfirmationButtons}
        nextStep={nextStep}
        handleNextStep={handleNextStep}
        allStepsCompleted={allStepsCompleted}
        handleExplainSolution={handleExplainSolution}
        allQuestionsCompleted={isAllQuestionsCompletedNow}
        isSolutionByImage={isSolutionByImage}
        handleUpsertExerciseHistory={handleUpsertExerciseHistory}
        onMessageRendered={handleMessageRendered}
        isFromSelfTestAnswerPreview={isFromSelfTestAnswerPreview}
      />
      <ChatFooter
        inputMessage={inputMessage}
        setInputMessage={setInputMessage}
        handleSubmit={handleSubmit}
        handleKeyDown={handleKeyDown}
        isLoading={isLoading}
        selectedQuestionId={selectedQuestionId}
        selectedQuestion={selectedQuestion}
        currentStepIndex={currentStepIndex}
        placeholderText={t("chatInputPlaceHolder")}
        isSendDisabled={inputMessage.trim().length < 10}
      />
    </div>
  );
}